import { FileImageOutlined } from "@ant-design/icons";
import { Form, Input, Modal, Switch, Select } from "antd";
import React, { useState } from "react";
import ReactQuill from "react-quill";
import { api } from "services/api";
import Swal from "sweetalert2";
import { IAddCourses } from "types";
import { getBase64Img } from "utils";

export const AddCourseModal: React.FC<IAddCourses> = ({ ...props }) => {
	const [value, setValue] = useState<string>("");
	const [currTags, setCurrTags] = useState<string[]>([]);
	const [option, setOption] = useState<string>("");
	const [courseHighlight, setCourseHighlight] = useState<boolean>(false);
	const [imageWasAdded, setImageWasAdded] = useState<boolean>(false);
	const [isActive, setIsActive] = useState<boolean>(false);

	const {
		form,
		isOpen,
		setCurrentImgURL,
		setIsOpen,
		courseStatus,
		currentImgURL,
		setCourseStatus,
		setCourses,
	} = props;

	const handleChange = (value: string) => {
		setCurrTags(Array.from(value));
	};

	const handleRegister = (values: any) => {
		api
			.post("/courses", values)
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;
					setCourses && setCourses(undefined);
					api.get("/courses").then((res) => {
						setCourses && setCourses(res.data.data.courses);
					});
					form.resetFields();
					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setIsOpen(false);
						form.resetFields();
						setCurrentImgURL("");
						setCurrTags([]);
						setCourseStatus(false);
						setValue("");
						setCourseHighlight(false);
						setIsActive(false);
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};
	const { Option } = Select;

	return (
		<Modal
			title={<p style={{ margin: 0 }}>Cadastrar novo curso</p>}
			open={isOpen}
			maskClosable={false}
			okText="Cadastrar curso"
			cancelText="Cancelar"
			onOk={() => {
				form
					.validateFields()
					.then((values) => {
						const allValues = imageWasAdded
							? {
									...values,
									tags: currTags.join(", "),
									status: courseStatus ? "publish" : "pending",
									image: currentImgURL,
									image_to_list: currentImgURL,
									visibility: option,
									is_highlight: courseHighlight,
									content: value,
									is_active: isActive,
									subtitle: form.getFieldValue("subtitle"),
									description: form.getFieldValue("description"),
							  }
							: {
									...values,
									tags: currTags.join(", "),
									status: courseStatus ? "publish" : "pending",
									visibility: option,
									is_highlight: courseHighlight,
									content: value,
									is_active: isActive,
									subtitle: form.getFieldValue("subtitle"),
									description: form.getFieldValue("description"),
							  };
						handleRegister(allValues);
						console.log(allValues);
					})
					.catch((info) => {
						console.log("Validate Failed:", info);
					});
			}}
			onCancel={() => {
				setIsOpen(!isOpen);
				form.resetFields();
				setCurrentImgURL("");
				setCurrTags([]);
				setCourseStatus(false);
				setValue("");
				setCourseHighlight(false);
				setIsActive(false);
			}}
			className="modal-courses"
		>
			<Form form={form} name="new-course" autoComplete="off">
				<div className="m-courses-modal">
					<div className="m-courses-modal__login-info">
						<div className="m-courses-modal__login-info__avatar">
							{currentImgURL ? (
								<img src={currentImgURL} alt="" width="100%" height="100%" />
							) : (
								<FileImageOutlined />
							)}
							<label
								htmlFor="avatar"
								className="m-courses-modal__login-info__avatar__btn"
							>
								Escolha uma foto
							</label>
							<Input
								id="avatar"
								type="file"
								accept="image/*"
								style={{ display: "none" }}
								onChange={(e) => {
									if (e.target.files?.[0]) {
										setImageWasAdded(true);
										getBase64Img(e.target.files?.[0] as Blob, setCurrentImgURL);
									}
								}}
							/>
						</div>
						<div className="m-courses-modal__login-info__inputs">
							<Form.Item
								name="title"
								rules={[
									{
										required: true,
										message: "Título necessário",
									},
								]}
							>
								<Input placeholder="Título do curso" />
							</Form.Item>
							<Form.Item
								name="description"
								rules={[
									{
										required: true,
										message: "Descrição necessária",
									},
								]}
							>
								<Input placeholder="Descrição do curso" />
							</Form.Item>

							<Form.Item
								name="subtitle"
								rules={[
									{
										required: true,
										message: "Subtítulo necessário",
									},
								]}
							>
								<Input placeholder="Subtítulo do curso" />
							</Form.Item>

							<Form.Item
								name="author"
								rules={[
									{
										required: true,
										message: "Autor necessário",
									},
								]}
							>
								<Input placeholder="Autor" />
							</Form.Item>
						</div>
					</div>
					<div
						style={{
							width: "100%",
							display: "flex",
							flexDirection: "column",
						}}
					>
						<div className="m-courses-modal__tags">
							<Form.Item name="tags" style={{ margin: 0, width: "60.5%" }}>
								<Select
									mode="tags"
									placeholder="Tags"
									tokenSeparators={[" "]}
									allowClear
									onClick={() => {
										const noDataName = document.getElementsByClassName(
											"ant-empty-description"
										)[0];

										if (noDataName) {
											noDataName.innerHTML = "Nenhuma tag cadastrada";
										}
									}}
									onChange={handleChange}
								></Select>
							</Form.Item>
							<Form.Item
								name="age"
								rules={[
									{
										required: true,
										message: "Classificação necessária",
									},
								]}
							>
								<Input placeholder="Classificação indicativa" />
							</Form.Item>
						</div>
						<div
							style={{
								display: "flex",
								width: "100%",
								alignItems: "center",
								justifyContent: "space-between",
								marginTop: "15px",
							}}
						>
							<Form.Item
								name="visibility"
								rules={[
									{
										required: true,
										message: "Visibilidade necessária",
									},
								]}
								style={{ margin: 0, width: "38%" }}
							>
								<Select
									placeholder="Visibilidade"
									className="select"
									onChange={(e) => setOption(e)}
								>
									<Option value="public">Público</Option>
									<Option value="private">Privado</Option>
								</Select>
							</Form.Item>
							<div
								className="m-news-modal__status"
								style={{ margin: "0 10px 0 10px" }}
							>
								<p>Publicado</p>
								<Switch
									checked={courseStatus}
									onClick={(e) => setCourseStatus(e)}
								/>
							</div>
							<div
								className="m-news-modal__status"
								style={{ margin: "0 10px 0 0px" }}
							>
								<p>Destacar</p>
								<Switch
									checked={courseHighlight}
									onClick={(e) => setCourseHighlight(e)}
								/>
							</div>
							<div className="m-news-modal__status">
								<p>Ativo</p>
								<Switch checked={isActive} onClick={(e) => setIsActive(e)} />
							</div>
						</div>
					</div>

					<div
						className="m-courses-modal__textarea"
						style={{ marginTop: "5px" }}
					>
						<ReactQuill theme="snow" value={value} onChange={setValue} />
					</div>
				</div>
			</Form>
		</Modal>
	);
};
